import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { createStructuredSelector } from 'reselect';

import { getTopSalesActions } from '../../../redux/actions/getTopSalesActions';
import { makeIsReloadAboutWholeHome } from '../../../redux/selectors/homepageSelector';
import {
  makeTopSalesDataByKey,
  makeTopSalesList,
} from '../../../redux/selectors/topSalesSelector';
import TopSalesList from './TopSalesList';

const mapStateToProps = () => {
  const selector = createStructuredSelector({
    isFetching: makeTopSalesDataByKey('isFetching'),
    page: makeTopSalesDataByKey('page'),
    loadingType: makeTopSalesDataByKey('loadingType'),
    topSalesIdList: makeTopSalesList(10),
    isHomePageReload: makeIsReloadAboutWholeHome(),
  });

  return state => selector(state);
};

const mapDispatchToProps = dispatch => {
  return bindActionCreators(
    {
      getTopSalesList: getTopSalesActions.request,
    },
    dispatch
  );
};

export default connect(mapStateToProps, mapDispatchToProps, null, {
  forwardRef: true,
})(TopSalesList);
